import React from 'react';


// Stylesheet
import './Table.css';
import './table.scss';
// Translation
import { useTranslation } from 'react-multi-lang';


import MyPagination from '../pagination/pagination';
import SortWidget from '../SortWidget/SortWidget';
import { useGetSort } from '../../services/hoc/useSort';

interface DashboardTableProps {
  header: string[]; // Table header data

  onSelect?: Function; // Fire this function when the user selects a raw,
  hasMore?: boolean;
  loadMore?: Function;
  pagesInfo?: any;
  setPagesInfo?: Function;
  noPagination?: boolean;
  maxHeight?: string;
  className?: string;
  break_on_overflow?: boolean;
  sort_fields?: (number | undefined)[];
  fetchSortedData?: Function;
  state?: any[];
  header_cell_width?: string[];
  children: React.ReactElement | React.ReactElement[];
  handlePagination?: (page: number)=>void
}


export const SortTable = (props: DashboardTableProps) => {
  // Translation
  const t = useTranslation();
  const { handleSort, sortChecked } = useGetSort(
    props.sort_fields,
    props.fetchSortedData,
  );
  

  const handlePage =(val:number)=>{
   if  (props &&
            props.setPagesInfo &&
            typeof props.setPagesInfo === 'function'){
              props.setPagesInfo((pre: any) => ({ ...pre, page: val }))
              if (props.handlePagination) props.handlePagination(val)
            }
    
  }
  return (
    <div
      className={`dashboard-table ${props.className}`}
      style={{
        maxHeight: props.maxHeight ? props.maxHeight : '',
        height: props.maxHeight ? props.maxHeight : '',
        overflow: props.maxHeight ? 'auto' : '',
        width: props.maxHeight ? '100%' : '',
      }}
      id="scrollableDiv"
      >
      <table>
        {
          /* props.hasMore && */ props.state?.length === 0 ? (
            ''
          ) : (
            <thead>
              <tr>
                {props.onSelect && <th style={{maxWidth:'50px'}}></th>}
                {props.header.map((item, index) => (
                  <th
                    style={
                      item
                        ? {
                            width: props.header_cell_width
                              ? props.header_cell_width[index]
                              : undefined,
                              textAlign:'center'
                          }
                        : { width: '200px' }
                    }
                    key={index}
                    onClick={() => handleSort(index)}>
                    <SortWidget
                      item={item}
                      index={index}
                      sort={sortChecked}
                      show={props.sort_fields?.[index]}
                    />
                  </th>
                ))}
              </tr>
            </thead>
          )
        }
        {!props.hasMore && props.state?.length === 0 ? (
          <tr className="no-items text-center">
            <td>{t('no_items_in_table')}</td>
          </tr>
        ) : (
          ''
        )}
          <tbody>
               {props.children}

          </tbody>
      </table>
      {props.noPagination ? null : (
        <MyPagination
          page={props.pagesInfo.page}
          lastPage={props.pagesInfo.lastPage}
          setPage={(val: number) =>
            handlePage(val)
          }
        />
      )}
    </div>
  );
};

export const PrintTable = (props: { children: React.ReactNode }) => {
  return (
    <div className="print-container">
      <table className="print-table">{props.children}</table>
    </div>
  );
};
